import { Pipe, PipeTransform } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { ClientData } from "../../providers/client";

@Pipe({
  name: "userData",
})
export class UserDataPipe implements PipeTransform {

  constructor(
    private clientData: ClientData,
  ) { }

  public transform(user: any, clientId: string) {
    if (user) {
      if (!user.displayName) {
        return this.clientData.getUserById(clientId, user.id);
      }
    }
    return Observable.of(user);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/user/user-data.ts